<template>
  <div>
    <v-card
      style="
        background-color: transparent;
        border-radius: 15px;
        margin-top: 2vw;
      "
      elevation="1"
    >
      <v-card-text>
        <v-container v-if="loading">
          <v-row dense class="mt-9" alig="center" justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-row dense class="course-content__topbar">
              <v-col cols="12" md="8">
                <div class="course-content__title-wrap">
                  <span class="text-h5 font-weight-bold">
                    {{ module.title }} - {{ module.category }}
                  </span>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="4"
                class="d-flex justify-end align-start flex-wrap"
              >
                <v-btn plain class="mb-2" @click="goBack()">
                  <v-icon>mdi-chevron-left</v-icon>
                  <strong style="text-transform: capitalize" class="texth7">
                    Voltar
                  </strong>
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
          <v-row style="margin-top: 3vw">
            <v-card
              elevation="1"
              class="mx-auto px-auto my-auto py-auto"
              width="100vw"
            >
              <v-card-text>
                <div class="course-section">
                  <div class="course-section__title">Descrição da aula</div>
                  <div class="course-section__body course-section__description">
                    {{ module.description || "Descrição não informada." }}
                  </div>
                </div>

                <div class="course-section">
                  <div class="course-section__title">Palavras chave</div>
                  <div class="course-section__body">
                    <v-expansion-panels v-if="module.keywords?.length">
                      <v-expansion-panel
                        v-for="(item, i) in module.keywords"
                        :key="i"
                      >
                        <v-expansion-panel-header>
                          {{ item.keyword }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <span class="text-h6">{{ item.description }}</span>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-alert v-else type="info" text class="mb-0">
                      Nenhuma palavra-chave cadastrada para esta aula.
                    </v-alert>
                  </div>
                </div>

                <div class="course-section">
                  <div class="course-section__title">
                    Apresentador de conteúdo
                  </div>
                  <div class="course-section__body">
                    <v-carousel
                      v-if="module.content?.length"
                      v-model="carouselIndex"
                      :cycle="false"
                      height="700"
                      hide-delimiters
                      show-arrows-on-hover
                      class="rounded-lg mt-3"
                    >
                      <v-carousel-item
                        v-for="(item, i) in module.content"
                        :key="i"
                        :class="{
                          'content-item-card': true,
                          'video-item': isVideo(item.type),
                        }"
                      >
                        <div
                          class="d-flex align-center px-4 pt-2 content-header"
                        >
                          <h3 class="text-h6 white--text">{{ item.name }}</h3>
                          <v-spacer></v-spacer>
                          <v-chip dark color="secondary-400" class="ma-2">{{
                            getItemTypeLabel(item.type)
                          }}</v-chip>
                          <v-chip dark color="secondary-400"
                            >Visualizando:
                            {{ carouselIndex ? carouselIndex + 1 : 1 }} /
                            {{ module.content.length }}</v-chip
                          >
                        </div>

                        <div
                          class="transparent-content-wrapper fill-height pa-4"
                        >
                          <div v-if="isPDF(item.type)" class="fill-height">
                            <iframe
                              :src="`${item.url}#toolbar=0`"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div v-else-if="isPPT(item.type)" class="fill-height">
                            <DocumentViewerIframe :file-url="item.url" />
                          </div>

                          <div
                            v-else-if="isVideo(item.type)"
                            class="d-flex justify-center align-center fill-height"
                          >
                            <video
                              :width="
                                $vuetify.breakpoint.smAndDown ? '100%' : '800'
                              "
                              height="500"
                              controls
                            >
                              <source :src="item.url" type="video/mp4" />
                              Seu navegador não suporta o elemento de vídeo.
                            </video>
                          </div>
                        </div>
                      </v-carousel-item>
                    </v-carousel>

                    <v-alert v-else type="info" text class="mb-0 mt-3">
                      Nenhum material foi disponibilizado para esta aula ainda.
                    </v-alert>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import DocumentViewerIframe from "@/components/DocumentViewerIframe.vue";
export default {
  name: "CourseContentPage",
  components: { DocumentViewerIframe },
  async created() {
    await this.loadContent();
  },
  data() {
    return {
      module: {},
      moduleId: "",
      loading: true,
      carouselIndex: 0,
    };
  },
  methods: {
    async loadContent() {
      this.loading = true;

      const moduleId = this.$route.params.id;
      const parentModuleId = this.$route.params.module || moduleId;

      await pitchPartnerApi
        .getCourseContent(parentModuleId, moduleId)
        .then((res) => {
          this.moduleId = moduleId;
          this.module = res.data.content;
          this.applyRequestedMaterial();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    applyRequestedMaterial() {
      const materialId = this.$route.query.material;

      if (!materialId || !Array.isArray(this.module.content)) {
        this.carouselIndex = 0;
        return;
      }

      const selectedIndex = this.module.content.findIndex(
        (item) => item.id === materialId
      );

      this.carouselIndex = selectedIndex >= 0 ? selectedIndex : 0;
    },
    goBack() {
      this.$router.back();
    },
    googleDocsViewerUrl(url) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true`;
    },
    isPDF(filename) {
      return filename.includes("pdf");
    },
    isVideo(filename) {
      return filename.includes("mp4");
    },
    isPPT(filename) {
      return (
        filename.includes("presentation") ||
        filename.includes("ppt") ||
        filename.includes("pptx") ||
        filename.includes("powerpoint")
      );
    },
    getItemTypeLabel(type) {
      if (this.isPDF(type)) return "PDF";
      if (this.isPPT(type)) return "PPT/Apresentação";
      if (this.isVideo(type)) return "Vídeo";
      return "Conteúdo";
    },
  },
  watch: {
    "$route.fullPath"() {
      this.loadContent();
    },
  },
};
</script>
<style scoped>
.course-content__topbar {
  width: 100%;
}

.course-content__title-wrap {
  display: flex;
  flex-direction: column;
}

.course-section {
  margin-top: 1.75rem;
  padding: 1.35rem;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(239, 246, 255, 0.78) 100%
  );
  border: 1px solid rgba(59, 130, 246, 0.12);
}

.course-section:first-child {
  margin-top: 0;
}

.course-section__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
}

.course-section__body {
  margin-top: 1rem;
}

.course-section__description {
  color: #374151;
  line-height: 1.7;
  font-size: 1rem;
}

.fill-height {
  height: 100%;
}

.v-carousel-item {
  background: #424242;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-header {
  background-color: rgba(0, 0, 0, 0.3);
  padding: 8px 16px;
  z-index: 1;
  width: 100%;
  flex-shrink: 0;
}

.transparent-content-wrapper {
  background-color: transparent !important;
  padding: 16px !important;
  flex-grow: 1;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.transparent-content-wrapper > div {
  height: 100%;
  width: 100%;
}

.transparent-content-wrapper iframe {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.content-item-card.video-item {
  background: #000000;
}

.transparent-content-wrapper video {
  max-width: 100%;
  max-height: 100%;
}
</style>
